import _jsx from "@babel/runtime/helpers/jsx";
var _OnlineOpinionForm;
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { OnlineOpinionForm } from 'reaxl-molecules';

/**
 *  Footer content injector adds third party content to the static footer
 *
 */

const FooterContentInjector = /*#__PURE__*/React.memo(() => {
  const [footerContentRef, setFooterContentRef] = useState();
  useEffect(() => {
    const contentRef = document.getElementsByClassName('footer-bar-content');
    setFooterContentRef(contentRef);
  }, []);
  return footerContentRef && footerContentRef.length > 0 ? /*#__PURE__*/ReactDOM.createPortal(_OnlineOpinionForm || (_OnlineOpinionForm = /*#__PURE__*/_jsx(OnlineOpinionForm, {})), footerContentRef[0]) : null;
});
export default FooterContentInjector;